module.exports = __webpack_public_path__ + "img/fruit-cranberries-350x184.f4c34724.jpg";